import { Relationship } from './relationship';
import { ProtoResponse } from '@lsq-frontend/angular-shared/api-service';
import { Error } from '@lsq-frontend/remote-services/all-java/common-mk0';

export class UpdateRelationshipEnrollmentResponse extends ProtoResponse {
    public ok = false;
    public relationship = new Relationship();
    public error: Error = null;
    constructor(obj?: {
       ok?: boolean;
       relationship?: Relationship;
       error?: Error;
    }) {
        super();
        if (obj != null) {
            const oneofSets = [
                [ 'relationship', 'error' ],
            ];
            oneofSets.forEach((oneof) => {
                const keysAssigned = oneof.filter((key) => typeof obj[key] !== 'undefined');
                const shouldThrow = keysAssigned.length > 1;
                if (shouldThrow) {
                    throw new (window as any).Error(
                        'Attempted to assign more than one property from a "oneof" definition.\n'
                        + 'May assign one of ' + oneof.join(' or ') + '.\n'
                        + 'Attempted to assign ' + keysAssigned.join(' and ') + '.'
                    );
                }
            });

            this.ok = typeof obj.ok === 'undefined' ? this.ok : obj.ok;
            this.relationship = typeof obj.relationship === 'undefined' ? this.relationship : obj.relationship;
            this.error = typeof obj.error === 'undefined' ? this.error : obj.error;
        }
    }
}
